import { Component } from '@theme/component';

class CardsWithVariants extends Component {
  /** @type {Array<string[]|string|null>} */
  nutritionData = [];

  connectedCallback() {
    super.connectedCallback();
    this.nutritionData = this.#parseNutrition();

    this.querySelectorAll('.cwv__card').forEach((card) => {
      card.addEventListener('click', () => this.#selectProduct(card));
    });

    const addToCartBtn = this.querySelector('.cwv__cta:not([href])');
    if (addToCartBtn) addToCartBtn.addEventListener('click', () => this.handleCta());
  }

  /** @param {Element} card */
  #selectProduct(card) {
    const index = parseInt(card.dataset.index ?? '0', 10);

    // Active state
    this.querySelectorAll('.cwv__card').forEach((c, i) => {
      const active = i === index;
      c.classList.toggle('cwv__card--active', active);
      c.setAttribute('aria-pressed', String(active));
    });

    // Product image
    const img = this.querySelector('.cwv__product-img');
    if (img) {
      img.src = card.dataset.image ?? '';
      img.alt = card.dataset.imageAlt ?? '';
    }

    // Nutrition
    const list = this.querySelector('.cwv__nutrition');
    if (list) {
      const items = this.#getNutritionItems(this.nutritionData[index]);
      list.innerHTML = items
        .map((item) => `<li class="cwv__nutrition-item">${this.#escapeHtml(String(item).toUpperCase())}</li>`)
        .join('');
    }

    // CTA link
    const cta = this.querySelector('.cwv__cta[href]');
    if (cta) cta.setAttribute('href', card.dataset.url ?? '#');
  }

  async handleCta() {
    const card = this.querySelector('.cwv__card--active');
    const variantId = card?.dataset.variantId;
    if (!variantId) return;

    const btn = this.querySelector('.cwv__cta:not([href])');
    const label = btn?.querySelector('[ref="ctaBtnLabel"]');
    const originalLabel = btn?.dataset.originalLabel ?? 'Add to Cart';

    if (btn) btn.disabled = true;
    if (label) label.textContent = '...';

    try {
      const res = await fetch(Theme.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
      });
      if (!res.ok) throw new Error();
      if (label) label.textContent = Theme.translations.added ?? 'Added!';
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    } catch {
      if (label) label.textContent = originalLabel;
    } finally {
      setTimeout(() => {
        if (btn) btn.disabled = false;
        if (label) label.textContent = originalLabel;
      }, 1500);
    }
  }

  /** @returns {Array<string[]|string|null>} */
  #parseNutrition() {
    const script = this.querySelector('script[type="application/json"]');
    if (!script) return [];
    try { return JSON.parse(script.textContent ?? '[]'); } catch { return []; }
  }

  /** @param {string[]|string|null|undefined} n @returns {string[]} */
  #getNutritionItems(n) {
    if (!n) return [];
    if (Array.isArray(n)) return n.filter(Boolean);
    if (typeof n === 'string') return n.split('\n').map((s) => s.trim()).filter(Boolean);
    return [];
  }

  /** @param {string} s @returns {string} */
  #escapeHtml(s) {
    return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
}

if (!customElements.get('cards-with-variants')) {
  customElements.define('cards-with-variants', CardsWithVariants);
}
